module.exports = {
	"config": {
		"siteTitle": "Lawrence Perlman Photography",
		"linkPrefix": "/gatsby-starter-default"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "contact.js",
				"ext": "js",
				"name": "contact",
				"extname": ".js",
				"basename": "contact.js",
				"dirname": "",
				"stem": "contact",
				"path": "contact.js"
			},
			"requirePath": "contact.js",
			"path": "/contact/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "exhibitions.js",
				"ext": "js",
				"name": "exhibitions",
				"extname": ".js",
				"basename": "exhibitions.js",
				"dirname": "",
				"stem": "exhibitions",
				"path": "exhibitions.js"
			},
			"requirePath": "exhibitions.js",
			"path": "/exhibitions/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "images.js",
				"ext": "js",
				"name": "images",
				"extname": ".js",
				"basename": "images.js",
				"dirname": "",
				"stem": "images",
				"path": "images.js"
			},
			"requirePath": "images.js",
			"path": "/images/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "images",
				"base": "cemeteries-photos.js",
				"ext": "js",
				"name": "cemeteries-photos",
				"extname": ".js",
				"basename": "cemeteries-photos.js",
				"dirname": "images",
				"stem": "cemeteries-photos",
				"path": "images/cemeteries-photos.js"
			},
			"requirePath": "images/cemeteries-photos.js",
			"path": "/images/cemeteries-photos/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "images",
				"base": "ice-shacks-photos.js",
				"ext": "js",
				"name": "ice-shacks-photos",
				"extname": ".js",
				"basename": "ice-shacks-photos.js",
				"dirname": "images",
				"stem": "ice-shacks-photos",
				"path": "images/ice-shacks-photos.js"
			},
			"requirePath": "images/ice-shacks-photos.js",
			"path": "/images/ice-shacks-photos/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "images",
				"base": "maine-photos.js",
				"ext": "js",
				"name": "maine-photos",
				"extname": ".js",
				"basename": "maine-photos.js",
				"dirname": "images",
				"stem": "maine-photos",
				"path": "images/maine-photos.js"
			},
			"requirePath": "images/maine-photos.js",
			"path": "/images/maine-photos/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "images",
				"base": "miscellaneous-photos.js",
				"ext": "js",
				"name": "miscellaneous-photos",
				"extname": ".js",
				"basename": "miscellaneous-photos.js",
				"dirname": "images",
				"stem": "miscellaneous-photos",
				"path": "images/miscellaneous-photos.js"
			},
			"requirePath": "images/miscellaneous-photos.js",
			"path": "/images/miscellaneous-photos/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "images",
				"base": "quebec-photos.js",
				"ext": "js",
				"name": "quebec-photos",
				"extname": ".js",
				"basename": "quebec-photos.js",
				"dirname": "images",
				"stem": "quebec-photos",
				"path": "images/quebec-photos.js"
			},
			"requirePath": "images/quebec-photos.js",
			"path": "/images/quebec-photos/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "images",
				"base": "silos-photos.js",
				"ext": "js",
				"name": "silos-photos",
				"extname": ".js",
				"basename": "silos-photos.js",
				"dirname": "images",
				"stem": "silos-photos",
				"path": "images/silos-photos.js"
			},
			"requirePath": "images/silos-photos.js",
			"path": "/images/silos-photos/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "images",
				"base": "trees-photos.js",
				"ext": "js",
				"name": "trees-photos",
				"extname": ".js",
				"basename": "trees-photos.js",
				"dirname": "images",
				"stem": "trees-photos",
				"path": "images/trees-photos.js"
			},
			"requirePath": "images/trees-photos.js",
			"path": "/images/trees-photos/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js"
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "page-2.js",
				"ext": "js",
				"name": "page-2",
				"extname": ".js",
				"basename": "page-2.js",
				"dirname": "",
				"stem": "page-2",
				"path": "page-2.js"
			},
			"requirePath": "page-2.js",
			"path": "/page-2/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "profile.js",
				"ext": "js",
				"name": "profile",
				"extname": ".js",
				"basename": "profile.js",
				"dirname": "",
				"stem": "profile",
				"path": "profile.js"
			},
			"requirePath": "profile.js",
			"path": "/profile/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 384
// module chunks = 0